import {
	NETWORK_ERROR_CODE,
	NETWORK_ERROR_MESSAGE,
} from "@workspace/base-api/fetchJson";
import type { ApiError } from "@workspace/base-api/fetchJson";

// HA-804 / HA-805: which message a failed PIN check shows. The server's "wrong PIN" is a 401 coded
// PIN_REJECTED (HA-805); a 401 without that code is the auth middleware saying the till's own
// session has expired. A 403 or a 500 is the server refusing or failing, and a dropped connection
// is the network. Shared by the check-in screen and the employee-centre login.

export const PIN_REJECTED_MESSAGE =
	"Invalid Staff ID or PIN. Please try again.";
export const PIN_CHECK_FAILED_MESSAGE =
	"We couldn't check your PIN. Please try again or ask a manager.";
export const TILL_SESSION_EXPIRED_MESSAGE =
	"This till's session has expired. Sign the till in again.";

/** HA-805: the problem code PinAuthenticationEndpoint gives a wrong PIN. */
export const PIN_REJECTED_CODE = "PIN_REJECTED";

/** The message for a PIN check the API answered with a failure (see toApiError). */
export function pinFailureMessage(
	failure: Pick<ApiError, "status" | "code">,
): string {
	if (failure.code === PIN_REJECTED_CODE) return PIN_REJECTED_MESSAGE;
	if (failure.status === 401) return TILL_SESSION_EXPIRED_MESSAGE;
	if (failure.code === NETWORK_ERROR_CODE) return NETWORK_ERROR_MESSAGE;
	return PIN_CHECK_FAILED_MESSAGE;
}

/** The message for something that THREW instead: a network-shaped error, or `fallback`. Never the PIN message. */
export function thrownFailureMessage(error: unknown, fallback: string): string {
	if (
		error instanceof TypeError ||
		(error instanceof DOMException &&
			(error.name === "AbortError" || error.name === "TimeoutError"))
	)
		return NETWORK_ERROR_MESSAGE;
	return fallback;
}
